import React from 'react'

class PageTitle extends React.Component {

    render() {
        return (
            <div>
                <div className="form-group">
                    <span className="col-sm-1"></span>
                    <h2 className="m-2 text-black-50"> {this.props.title}  <sub className='text-success'>{this.props.subTitle}</sub> </h2>
                   
                </div>
                <hr />
            </div>
        )
    }
}

export default PageTitle;
